/* eslint-disable class-methods-use-this */
import React from 'react';
import { useRouteData, useSiteData, Head } from 'react-static';
// template components
import Page from '@nmx/template/dist/componentLibrary/layout/Page';
// native components
import PageContent from './components/pageContent';

export default () => {
  const { config, dynamicConfig } = useSiteData();
  const { pageProps } = useRouteData();

  return (
    <Page
      {...pageProps} // defined in route.js
      headComponent={Head}
      dynamicConfig={dynamicConfig}
      config={config}
      breadcrumbsNavigationConfig={[
        {
          pageName: 'Home',
          linkUrl: '/',
          linkAriaLabel: 'Northwestern Mutual Home',
        },
        {
          pageName: 'Investing Disclosure',
          linkUrl: '/investing-disclosure/',
          linkAriaLabel: 'Northwestern Mutual Investing Disclosure',
        },
      ]}
      disableDisclaimerTopBorder={false}
      disclaimerFootnotes={[
        <>
          <sup>1</sup>&nbsp;In addition to the deposits insured up to &#36;250,000 per bank held in an individual capacity, funds deposited into accounts owned jointly by two or more people are aggregated and separately insured up to &#36;250,000 for each joint account owner, if each of the joint account owners is an individual person and has an equal right to withdraw funds from the account.
        </>,
        <>
          <sup>2</sup>&nbsp;FDIC Insured Deposit Program interest rates will fluctuate and are based on the prevailing market and the rates paid by the Program Banks participating in the program. Balances in this program are not insured by the SIPC.
        </>,
        <>
          No investment strategy can guarantee a profit or protect against loss. All investments carry some level of risk including the potential loss of principal invested. Financial Representatives do not give legal or tax advice. Taxpayers should seek advice based on their particular circumstances from an independent tax advisor.
        </>,
        <>
          Cash sweep product yields fluctuate. FDIC insured deposit programs are not covered by the SIPC. Money market funds are subject to SIPC coverage limits, but money market funds are not insured against market loss. An investment in any money market fund is not insured or guaranteed by the FDIC or any government agency. Although a money market fund seeks to preserve the value of your investment at &#36;1.00 per share, it is possible to lose money by investing in a money market fund.
        </>,
      ]}>

      <PageContent />

    </Page>
  );
};
